import LastPartsPurchasesList from '@/components/Operational/Inventory/Parts/LastPartsPurchasesList';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { PageProps } from '@/types/PageProps';
import { Divider } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

const SearchPartlatestPartPurchasesPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;

  const { partId } = useRouteMatch<{ partId: string }>().params;
  const basePath = `/app/searchParts/${partId}`;

  return (
    <DefaultRouteTabs
      route={route.parent}
      permissions={route.permissions}
      baseKey={partId}
      basePath={basePath}
    >
      <Helmet title={intl({ id: route.name })} />

      <LastPartsPurchasesList partId={Number(partId)} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/searchParts" />
      </SpaceForButton>
    </DefaultRouteTabs>
  );
};

export default SearchPartlatestPartPurchasesPage;
